import React from "react";

import { Doughnut } from "react-chartjs-2";

import ChartBase from "./ChartBase";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);
export const data = {
  labels: ["Product 1", "Product 2", "Product 3", "Product 4"],
  datasets: [
    {
      label: "Inventory Distribution",
      data: [13, 44, 55, 22],
      backgroundColor: ["#ED6C30", "#4C7B30", "#000", "#828282", "#fff", "red"],
      borderColor: ["#fff"],
      borderWidth: 1,
    },
  ],
};
const InventoryDistribution = (props) => {
  return (
    <div className={` ${props.customCss} `}>
      <ChartBase
        chartName="Inventory Distribution"
        subheading="Report Center"
        seeDetail={false}
        extraInfo={false}
        openComparePopUpToggle={props.openComparePopUpToggle}
      >
        <Doughnut data={data} />
      </ChartBase>
    </div>
  );
};
export default InventoryDistribution;
